var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-data-table',{attrs:{"headers":_vm.headers,"items":_vm.orders,"items-per-page":15},scopedSlots:_vm._u([{key:"item.client",fn:function(ref){
var item = ref.item;
return [_vm._v(_vm._s(item.user.account.name)+" - "+_vm._s(item.user.firstname)+" "+_vm._s(item.user.lastname))]}},{key:"item.status",fn:function(ref){
var item = ref.item;
return [_c('v-chip',{attrs:{"color":_vm.getColor(item.status),"dark":""}},[_vm._v(_vm._s(item.status))])]}},{key:"item.amount",fn:function(ref){
var item = ref.item;
return [_vm._v(_vm._s(_vm.formatAmount(item.amount)))]}},{key:"item.actions",fn:function(ref){
var item = ref.item;
return [_c('v-btn',{attrs:{"icon":""},on:{"click":function($event){return _vm.view(item)}}},[_c('v-icon',[_vm._v("mdi-dots-horizontal")])],1)]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }